import React from "react";
const FeaturedCard = ({brochureText , brochureImg}) => {
    return (
        <div className="down-box">
            <h5 className="down-title">Download <br /> Our Brochure</h5>
            <p>{brochureText}</p>
            <a href="/" className="btn btn-green">Download Here</a>
            <img src={brochureImg} className='img-fluid icon-img' width={"110px"} alt="" />
        </div>

    );
};

export default FeaturedCard;